import { memo } from "react";
interface ProgressRatingProps {
  items: ItemType[];
}

interface ItemType {
  label: string;
  value: number;
  count: number;
}

const ProgressRating = ({ items }: ProgressRatingProps) => {
  return (
    <div className="w-full max-w-62.5 md:max-w-full h-full flex flex-col justify-center gap-0.5">
      {items.map((it: ItemType) => (
        <div className="grid grid-cols-[1fr_auto]" key={it.label}>
          <div className="flex flex-row items-center justify-between">
            <div className="body_s text-content_secondary w-30 md:w-20 overflow-hidden text-ellipsis whitespace-nowrap">
              {it.label}
            </div>
            <div className="flex-1 h-[6px] rounded bg-background_white_overlay5 overflow-hidden">
              <div
                className="h-full bg-content_accent2_primary"
                style={{
                  width: `${Math.max(0, Math.min(100, it.value * 100))}%`,
                }}
              />
            </div>
          </div>
          <div className="body_s text-content_primary w-6 text-right">
            {it.count}
          </div>
        </div>
      ))}
    </div>
  );
};

export default memo(ProgressRating);
